<template>
    <div v-if="!loadingPage" class="pb-1">
        <validation-observer ref="loyaltySystemValidation" #default="{ invalid }">
            <b-form @submit.prevent>
                <div class="d-flex justify-content-between align-items-center">
                    <h3 class="text-primary mb-2">
                        <span>تنظیمات باشگاه</span>
                        <feather-icon @click="$bvModal.show('customer-club-description')" size="21"
                            icon="HelpCircleIcon" class="text-muted ml-75 pointer" />
                    </h3>
                    <b-button v-if="isAdminIdentityVerified" type="submit" variant="primary"
                        @click="validationForm('main')" :disabled="loading" class="d-flex mb-2">
                        <span>ذخیره تغییرات</span>
                        <b-spinner v-if="loading" class="ml-50" variant="white" small></b-spinner>
                    </b-button>
                </div>
                <div v-if="isAdminIdentityVerified">
                    <b-card>
                        <b-card-body>
                            <div>
                                <h5 class="font-weight-bolder">
                                    وضعیت باشگاه
                                </h5>
                                <h5>
                                    {{ loyaltySystemMode(loyaltySystemData.mode) }}
                                </h5>
                            </div>
                            <b-form-group label="توضیحات باشگاه" class="mt-2">
                                <validation-provider #default="{ errors }" name="توضیحات باشگاه" rules="required">
                                    <b-form-textarea dir="rtl" v-model="loyaltySystemData.description"
                                        class="text-primary-middle" rows="3" no-resize
                                        :state="errors.length > 0 ? false : null" />
                                    <small class="text-danger">{{ errors[0] }}</small>
                                </validation-provider>
                            </b-form-group>

                            <div v-for="(item, index) in loyaltySystemData.levels" :key="`level${index}`"
                                class="mt-2 rounded border-secondary p-2">
                                <h5 class="font-weight-bolder mb-1">{{ `سطح ${index + 1}` }}</h5>
                                <div class="row">
                                    <b-form-group label="نام" class="col-12 col-md-6 col-lg-3 mb-2">
                                        <validation-provider #default="{ errors }" name="نام" rules="required">
                                            <b-form-input dir="rtl" v-model="item.name" class="text-primary-middle"
                                                :state="errors.length > 0 ? false : null" />
                                            <small class="text-danger">{{ errors[0] }}</small>
                                        </validation-provider>
                                    </b-form-group>

                                    <b-form-group label="تصویر" class="col-12 col-md-6 col-lg-3 mb-2">
                                        <b-form-file :ref="'levelImageFileInput' + index" browse-text="بارگذاری"
                                            @change="(event) => addLevelImage(event, item, index)" placeholder="" />
                                    </b-form-group>

                                    <b-form-group label="درصد کش بک" class="col-12 col-md-6 col-lg-3 mb-2">
                                        <validation-provider #default="{ errors }" name="درصد کش بک" rules="required">
                                            <b-form-input dir="rtl" v-model="item.cashbackPercent"
                                                class="text-primary-middle" :state="errors.length > 0 ? false : null" />
                                            <small class="text-danger">{{ errors[0] }}</small>
                                        </validation-provider>
                                    </b-form-group>

                                    <b-form-group label="حداکثر امتیاز" class="col-12 col-md-6 col-lg-3 mb-2">
                                        <validation-provider #default="{ errors }" name="حداکثر امتیاز"
                                            :rules="index == loyaltySystemData.levels.length - 1 ? '' : 'required'">
                                            <b-form-input dir="rtl" v-model="item.max" class="text-primary-middle"
                                                :state="errors.length > 0 ? false : null" />
                                            <small class="text-danger">{{ errors[0] }}</small>
                                        </validation-provider>
                                    </b-form-group>

                                    <b-form-group label="توضیحات" class="col-12 col-md-12 col-lg-12 mb-2">
                                        <b-form-textarea dir="rtl" v-model="item.description"
                                            class="text-primary-middle" rows="3" no-resize />
                                    </b-form-group>
                                </div>
                            </div>
                            <b-button :disabled="loyaltySystemData.levels.length > 8" @click="validationForm('levels')"
                                class="mt-2" variant="outline-info">
                                ایجاد سطح جدید
                            </b-button>
                        </b-card-body>
                    </b-card>
                </div>
                <b-card v-if="!isAdminIdentityVerified">
                    <div class="d-flex align-items-center justify-content-center flex-wrap text-danger text-center">
                        <span>برای دسترسی به این قسمت، لطفا</span>
                        <router-link class="mx-25" to="/identity-management">هویت</router-link>
                        <span>خود را تایید کنید.</span>
                    </div>
                </b-card>
            </b-form>
        </validation-observer>

        <!------------------------------- modal customer club description ------------------------------->
        <b-modal id="customer-club-description" title="تنظیمات باشگاه مشتریان" centered :hide-footer="true"
            title-class="font-weight-bolder" size="md">
            <div class="p-75">
                <p v-for="(item, index) in educationalDescription" :key="index">
                    {{ item }}
                </p>
            </div>
        </b-modal>
    </div>
</template>

<script>
import { BButton, BCard, BCardText, BAvatar, BSpinner, BCardBody, BFormInput, BFormGroup, BForm, BFormTextarea, BFormFile } from 'bootstrap-vue';
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import { storeService } from '@core/services';
import { required } from '@validations';
import Compressor from 'compressorjs';


export default {
    components: {
        BFormInput,
        BCard,
        BCardText,
        BCardBody,
        BAvatar,
        BButton,
        BSpinner,
        ValidationProvider,
        ValidationObserver,
        BFormGroup,
        BForm,
        BFormTextarea,
        BFormFile
    },
    data() {
        return {
            required,
            loading: false,
            loadingPage: true,
            isAdminIdentityVerified: false,
            storeId: null,
            loyaltySystemData: {
                description: null,
                levels: [],
                mode: 0
            },
            educationalDescription: [
                'در هر زمان می‌توانید بین 1 تا 9 سطح ایجاد کنید.',
                'به دلیل مسائل امنیتی، امکان حذف سطوح وجود ندارد. اما می‌توانید در هر زمان سطح جدیدی ایجاد کرده و یا جزئیات سطوح موجود را ویرایش کنید.',
                'توجه داشته باشید در صورت ویرایش "حداکثر امتیاز" سطوح، کارت فعال و سطح کنونی مشتریان تغییر خواهد کرد.',
                'فیلد "حداکثر امتیاز" در هر سطح، بیشترین امتیازی است که مشتریان می‌تواند در آن سطح کسب کنند.',
                'مشتریان با توجه به مبلغ پرداخت شده هر 10،000 تومان یک امتیاز دریافت خواهند کرد.',
                'فیلد "درصد کش بک" میزان درصدی است که مشتریان بعد از هر خرید با توجه به مبلغ پرداخت شده، دریافت می‌کنند.',
                'تصاویر سطوح در بازه زمانی 1 الی 12 ساعت تأیید می‌شوند و قابل نمایش خواهند بود.',
                'نسبت تصویر سطوح باید 16:9 باشد.'
            ]
        }
    },
    computed: {
        loyaltySystemMode() {
            return (status) => {
                if (status == 0) {
                    return 'غیرفعال'
                }
                if (status == 1) {
                    return 'فعال (کش بک و امتیازدهی)'
                }
                if (status == 2) {
                    return 'فعال (کش بک)'
                }
                if (status == 3) {
                    return 'فعال (امتیازدهی)'
                }
            }
        }
    },
    methods: {
        addLevelImage(event, item, index) {
            if (event.target.files[0].size < 1000000) {
                if (event.target.files[0].type === "image/jpeg") {
                    const file = event.target.files[0];
                    new Compressor(file, {
                        quality: 0.6,
                        success: (result) => {
                            item.image = result
                        },
                    });

                }
                else {
                    this.$refs['levelImageFileInput' + index][0].reset();
                    this.$notif({ type: 'normal', title: 'فرمت وارد شده باید jpeg یا jpg باشد' });
                }
            }
            else {
                this.$refs['levelImageFileInput' + index][0].reset();
                this.$notif({ type: 'normal', title: 'حجم تصویر باید کمتر از 1 مگابایت باشد' });
            }
        },
        addLevel() {
            this.loyaltySystemData.levels.push({
                name: null,
                min: null,
                cashbackPercent: null,
                max: null,
                description: null,
                image: null
            })
        },
        validationForm(type) {
            this.$refs.loyaltySystemValidation.validate().then((success) => {
                if (success) {
                    if (type == 'main') {
                        if (this.loyaltySystemData.levels.length >= 1) {
                            this.loyaltySystem()
                        }
                        else {
                            this.$notif({ type: 'normal', title: 'حداقل یک سطح نیاز است' });
                        }
                    }
                    if (type == 'levels') {
                        this.addLevel()
                    }
                }
            });
        },
        getCompletionStatus() {
            storeService.getCompletionStatus(this.storeId).then(({ data }) => {
                this.isAdminIdentityVerified = data.isAdminIdentityVerified
                if (this.isAdminIdentityVerified) {
                    this.getLoyaltySystem();
                }
                else {
                    this.loadingPage = false;
                }
            })
        },
        getLoyaltySystem() {
            storeService.getLoyaltySystem(this.storeId).then(({ data }) => {
                this.loyaltySystemData.mode = data.mode
                this.loyaltySystemData.levels = data.levels
                for (let index in this.loyaltySystemData.levels) {
                    this.loyaltySystemData.levels[index].image = null
                }
                this.loyaltySystemData.description = data.description
                this.loadingPage = false;
            })
        },
        loyaltySystem() {
            this.loading = true
            let formData = new FormData();
            formData.append('LoyaltySystemDescription', this.loyaltySystemData.description);
            for (let index in this.loyaltySystemData.levels) {
                let indexNumber = Number(index)
                formData.append(`Levels[${index}].Name`, this.loyaltySystemData.levels[index].name);
                formData.append(`Levels[${index}].CashbackPercent`, this.loyaltySystemData.levels[index].cashbackPercent);
                if (this.loyaltySystemData.levels[index].image) {
                    formData.append(`Levels[${index}].Image`, this.loyaltySystemData.levels[index].image, this.loyaltySystemData.levels[index].image.name);
                }
                if (this.loyaltySystemData.levels[index].description) {
                    formData.append(`Levels[${index}].Description`, this.loyaltySystemData.levels[index].description);
                }
                if (Number(index) !== this.loyaltySystemData.levels.length - 1) {
                    formData.append(`Levels[${index}].Max`, this.loyaltySystemData.levels[index].max);
                }
                if (Number(index) !== 0) {
                    formData.append(`Levels[${index}].Min`, Number(this.loyaltySystemData.levels[indexNumber - 1].max) + 1);
                }
                if (Number(index) === 0) {
                    formData.append(`Levels[${index}].Min`, '0');
                }
            }
            storeService.loyaltySystem(this.storeId, formData).then(({ data }) => {
                this.$notif({ type: 'success', title: 'عملیات با موفقیت انجام شد' });
            })
                .finally(() => {
                    this.loading = false
                });
        }
    },
    mounted() {
        this.storeId = localStorage.getItem("storeId");
        this.getCompletionStatus();
    },
};
</script>